import { PureComponent, type ReactNode } from "react";
import * as ReactDOM from "react-dom";

let modalRoot: HTMLDivElement;

class ModalContainer extends PureComponent<{ children: ReactNode }> {
  el: HTMLDivElement;

  constructor(props: { children: ReactNode }) {
    super(props);
    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement("div");

    if (!modalRoot) {
      modalRoot = document.createElement("div");
      modalRoot.id = "reactModalRoot";
      document.body.appendChild(modalRoot);
    }
  }

  componentDidMount() {
    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default ModalContainer;
